module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addDocument":"Upload a document","deleteError":"Error deleting document"},"fr":{"addDocument":"Téléversez un document","deleteError":"Erreur de suppression du document"}}')
  delete Component.options._Ctor
}
